<template>
  <v-layout column wrap>
    <v-flex
      v-if="!embedded"
      sm6 xs12
      :class="{'pr-0 pb-4 mt-0': $vuetify.breakpoint.smAndDown, 'mt-0 pr-0 pb-0': $vuetify.breakpoint.mdAndUp}">
      <v-flex pb-4>
        <h4 class="opacity-54">{{title}}</h4>
        <LocationMap
          v-if="!embedded"
          :name="title"
          :address="data"
          :defaultLocation="field.default_value"
          :readonly="readonly"
          v-on:update-item="updateLocation">
        </LocationMap>
      </v-flex>
      <v-flex>
        <AddressField
          v-if="!embedded"
          :field="addressField"
          :data="data"
          v-on:update-item="updateLocation">
        </AddressField>
      </v-flex>
    </v-flex>
    <v-layout v-else>
      <v-flex class="bucket-field" @click="mapDialog = !mapDialog">
        <h5 class=" ml-1 pa-1 caption">{{title}}</h5>
        <div :class="'px-2 text-truncate'">
          {{addressData}}
        </div>
      </v-flex>
      <v-btn
        icon
        @click="mapDialog = !mapDialog"
        color="secondary"
        class="ma-1 my-2 white--text">
        <font-awesome-icon size="lg" :icon="['far', data ? 'map-marked' : 'map']" ></font-awesome-icon>
      </v-btn>
    </v-layout>
      <v-dialog
        v-model="mapDialog"
        max-width="800">
        <v-card pa-4>
          <v-flex pa-2>
            <h4 class="pl-2 opacity-54">{{title}}</h4>
            <LocationMap
              v-if="embedded && mapDialog"
              :name="title"
              :row="row"
              :address="data"
              :defaultLocation="field.default_value"
              :readonly="readonly"
              v-on:update-item="updateLocation">
            </LocationMap>
          </v-flex>
          <v-flex pa-2>
            <AddressField
              v-if="embedded && mapDialog"
              :field="addressField"
              :data="data"
              v-on:update-item="updateLocation">
            </AddressField>
          </v-flex>
        </v-card>
      </v-dialog>
  </v-layout>
</template>

<script>
import AddressField from "@/components/cases/case-elements/AddressField.vue"
import LocationMap from "@/components/cases/case-elements/LocationMap.vue"
import Helpers from "@/helpers.js"

export default {
  name: "location-field",
  components: { LocationMap, AddressField },
  props: {
    field: {
      type: Object
    },
    data: {
      type: Object
    },
    embedded: {
      type: Boolean,
      default: false
    },
    row: {
      type: Number
    }
  },
  data: () => {
    return {
      mapDialog: false
    }
  },
  computed: {
    addressField() {
      return {
        name: this.field.name,
        type: "address",
        readonly: this.readonly
      }
    },
    addressData() {
      if (this.data) {
        if (this.data.name) {
          if (this.data.country) {
            return this.data.name + ", " + this.data.country
          } else {
            return this.data.name
          }
        } else {
          return this.data
        }
      } else {
        if (this.field.default_value !== undefined) {
          return this.field.default_value
        } else {
          return ""
        }
      }
    },
    readonly() {
      let readonly = false
      if (this.field && this.field.readonly) { readonly = this.field.readonly }
      return readonly
    },
    title() {
      return this.field.display_name
        ? this.field.display_name
        : Helpers.capitalizeRemoveUnderscores(this.field.name)
    }
  },
  methods: {
    updateLocation(update) {
      this.$emit('update-item', { field: this.field.name, data: update.data, row: this.row })
    }
  }
}
</script>
